import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const editorialSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://allchinabuy.art/editorial-policy#webpage",
  "url": "https://allchinabuy.art/editorial-policy",
  "name": "Editorial Policy — allchinabuy.art",
  "description": "At allchinabuy.art, editorial integrity is our highest priority. Every product listing undergoes a rigorous community-driven verification process before publication.",
  "inLanguage": "en-US",
  "isPartOf": {
    "@type": "WebSite",
    "@id": "https://allchinabuy.art/#website",
    "url": "https://allchinabuy.art/",
    "name": "allchinabuy.art"
  },
  "dateModified": "2026-06-25"
};

export default function EditorialPolicy() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(editorialSchema) }}
      />
      {/* Schema.org BreadcrumbList */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://allchinabuy.art/" },
              { "@type": "ListItem", "position": 2, "name": "Editorial Policy", "item": "https://allchinabuy.art/editorial-policy" }
            ]
          }),
        }}
      />
      <Navbar />
      <main>
        <section className="pt-24 pb-12 md:pt-32 md:pb-16 bg-background-50">
          <div className="max-w-3xl mx-auto px-6 md:px-10">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors mb-6 cursor-pointer">
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </Link>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6">Editorial Policy</h1>
            <div className="prose prose-sm md:prose-base max-w-none text-foreground-600 leading-relaxed space-y-4">
              <p>
                At allchinabuy.art, editorial integrity is our highest priority. Every product listing, QC guide, and recommendation featured in our AllChinaBuy Spreadsheet undergoes a rigorous community-driven verification process before publication.
              </p>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Our Verification Standards</h2>
              <p>
                Products are only added to the spreadsheet after multiple community members have independently verified their quality. We require real QC photos, honest assessments of materials and craftsmanship, and documented shipping experiences. No product is featured based on a single review or unverified claim.
              </p>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Weekly Updates</h2>
              <p>
                Our spreadsheet is refreshed every week. Outdated listings are removed, broken links are fixed, and new verified finds are added. We maintain transparent update logs so you always know what has changed.
              </p>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Independence</h2>
              <p>
                allchinabuy.art operates independently. We do not accept payments from sellers in exchange for placement in the spreadsheet. Our recommendations are driven entirely by community feedback and quality verification results. For more details, visit our <Link to="/privacy-policy" className="text-primary-500 hover:text-primary-600 font-medium cursor-pointer">Privacy Policy</Link>.
              </p>
            </div>
            <nav className="mt-8 text-xs text-foreground-400" aria-label="Breadcrumb">
              <ol className="flex items-center gap-2 flex-wrap">
                <li><Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">Home</Link></li>
                <li><i className="ri-arrow-right-s-line text-[10px]"></i></li>
                <li className="text-foreground-600">Editorial Policy</li>
              </ol>
            </nav>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}